<template>
  <div class="card login-container row">
    <div class="card-body row">
      <div class="page left col-sm-6 col-12">
        <div class="text-description mb-3" v-html="t('_loginText')"></div>
      </div>
      <div class="page right col-sm-6 col-12">
        <login :login="login"
               :userStore="this.getUserStore()"
               :forgotPasswordLink="{name: 'lostPassword'}"
               :registrationLink="{name: 'register'}"
               @loggedIn="$router.push({name: 'accountCheckPin'})"
               @failedToLogin="$store.dispatch('alert/error', $event.data.status)"
        >
        </login>
        <div class="h4">{{t('Video instructions')}}</div>
        <div align="center" class="webinar-video embed-responsive embed-responsive-16by9">
          <video controls class="embed-responsive-item">
            <source :src="videoLink" type="video/mp4">
          </video>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
    import Login from '../../core/Components/User/Login';

    export default {
        components: {
            Login
        },
        computed: {
              videoLink() {
                  return window.location.protocol + '//' + window.location.hostname +'/www/webinar_mendel.mp4';
              }
        },
        methods: {
            login(data) {
                data.localVars = this.getLocalVars();
                return this.$store.dispatch('account/login', data).then(response => {
                    let loggedUser = this.$store.getters['account/userStore'].getLoggedUser();
                    let accountData = loggedUser.getAccountData();
                    if (!accountData) {
                        return this.$store.dispatch('account/get').then(response => {
                            loggedUser.setAccountData(response);
                            return true;
                        });
                    }
                });
            },
            getLocalVars() {
                let localVars = {};
                let skip = ['titan-ADM', 'titan-lang-ADM', 'securityPin', 'loglevel:webpack-dev-server'];
                Object.keys(localStorage).forEach(key => {
                    if (!skip.includes(key)) {
                        let decoded = null;
                        try {
                            decoded = JSON.parse(localStorage.getItem(key));
                        } catch (e) {
                            decoded = localStorage.getItem(key);
                        }
                        localVars[key] = decoded;
                    }
                });
                return JSON.stringify(localVars);
            }
        },
    }
</script>
<style lang="scss">
  .login-container {
    .h4 {
      margin-top: 1rem;
      margin-bottom: 0;
    }

    .left {
      border-right: 1px solid #ced4da;
      /*background: white;*/
    }

    .webinar-video {
      margin-top: 0.5rem;
    }
  }

  .text-description {
    /*text-align: justify;*/

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        position: relative;
        padding-left: 25px;
        padding-bottom: 5px;

        $top: 5px;
        $left: 0px;
        $size: 18px;

        &:before {
          position: absolute;
          top: $top;
          left: $left;

          content: "";
          width: $size;
          height: $size;
          background: #3ac165;
          border-radius: 50%;
        }

        &:after {
          $borderWidth: 2px;

          position: absolute;
          top: $top + 3px;
          left: $left + 6px;

          content: "";
          display: inline-block;
          transform: rotate(45deg);
          height: 10px;
          width: 6px;
          border-bottom: $borderWidth solid #fff;
          border-right: $borderWidth solid #fff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/public/Login.vue